import { render, staticRenderFns } from "./module-data-row.vue?vue&type=template&id=10431ee1&scoped=true"
import script from "./module-data-row.vue?vue&type=script&lang=js"
export * from "./module-data-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10431ee1",
  null
  
)

export default component.exports